export default {
  // Cor da Navegação
  "app-bar": "#2b3643",
  "app-bar-text": "#EEEEEE",
  "app-bar-highlighted": "#515151",

  // Cores da Marca
  "brand-lighten": "#0090DF",
  "brand-medium": "#006DA9",
  "brand-darken": "#36475B",

  // Cores Padrão
  primary: "#0090DF",
  secondary: "#595F73",
  // accent: "",
  // anchor: "",

  // Cores de Feedback
  success: "#1ABC9B",
  error: "#EA4E49",
  warning: "#F0AD4F",
  info: "#006DA9",

  // Cores Estruturais
  black: "#000000",
  "neutral-1": "#F5F6FB",
  "neutral-2": "#EAEDF8",
  "neutral-3": "#8B91A8",
  "neutral-4": "#595F73",
  white: "#FFFFFF",

  // Cores Complementares
  green: "#5DB85C",
  purple: "#9B59B6",
  yellow: "#F0AD4F",
  pink: "#FF3D70",
  blue: "#5CC1DF",
  orange: "#FF7663",
};
